import gql from 'graphql-tag';

export default gql`
  query schoolOrDistrictRegistration($id: ID!) {
    schoolOrDistrictRegistration(id: $id) {
      id
      agreementId
      numberOfSchools
      discountCode
      contactName
      contactPhoneNumber
      ncesSchoolId
      schoolName
      ncesDistrictId
      districtName
      address
      paymentStatus
      agreementStatus
      canSetup
      status
      agreementSignerId
      paymentAssigneeId
      pricingInfo {
        discountRate
        startUpFeePerSchool
        totalAmount
      }
      agreementAssignee {
        firstName
        lastName
      }
      paymentAssignee {
        firstName
        lastName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/gql/schoolOrDistrictRegistration.query.js